module.exports = __webpack_public_path__ + "static/media/design01.0569c763.jpg";